/* eslint-disable eqeqeq */
import formatMoney from "accounting-js/lib/formatMoney";
import { addDays, endOfWeek, isDate, isValid, parse, startOfWeek } from "date-fns";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import moment from "moment";
import numeral from 'numeral';
import Papa from 'papaparse';
import { v4 as uuid_v4, validate as validate_uuid } from "uuid";

import { TimePickerComponent } from "@syncfusion/ej2-react-calendars";

// import { validate as validate_uuid } from "uuid";
import { ShowToast } from './ToastHelper';
function withoutProperty(obj, property) {
  const { [property]: unused, ...rest } = obj

  return rest
}

export function SelectObjectKeys(obj, keys) {
  let newObj = {};
  let keysToSelect = keys;
  if (keys === undefined || keys == null) {
    keysToSelect = Object.keys(obj);
  } else if (!Array.isArray(keys)) {
    keysToSelect = [keys];
  }

  for (let key of keysToSelect) {
    newObj[key] = obj[key];
  }

  return newObj;
}

export function RemoveObjectKeys(obj, keys) {
  let newObj = obj;
  let keysToRemove = keys;
  if (!Array.isArray(keys)) {
    keysToRemove = [keys];
  }

  for (let key of keysToRemove) {
    newObj = withoutProperty(newObj, key)
  }

  return newObj
}

export function IsTrue(val) {
  return val === 1 || val === '1' || val === true || val === 'true';
}

export function GetShiftStartEnd({ work_date, shift_start, shift_end }) {
  const _date = moment(work_date);
  if (!_date.isValid() || IsEmptyOrNullOrUndefined(shift_start) || IsEmptyOrNullOrUndefined(shift_end)) {
    return { start: '', end: '' }
  }

  let start = moment(`${_date.format("YYYY-MM-DD")} ${shift_start}}`, 'YYYY-MM-DD HH:mm:ss');
  let end = moment(`${_date.format("YYYY-MM-DD")} ${shift_end}}`, 'YYYY-MM-DD HH:mm:ss');
  if (end.isSameOrBefore(start)) {
    end = end.add(1, "day");
  }
  return { start: start.format("DD-MMM-YYYY hh:mm A"), end: end.format("DD-MMM-YYYY hh:mm A") }
}

export function CreateKeyValues({ obj, defaultValues }) {
  let _vals = {};
  for (const key in obj) {
    _vals[key] = obj[key] !== undefined && obj[key] !== null && obj.hasOwnProperty(key)
      ? obj[key]
      : defaultValues[key]
      ;
  }
  return _vals;
}

export function getWeekStartEnd(date, weekStartsOn = 0, numberOfWeeks = 1) {
  const start = startOfWeek(date, { weekStartsOn })
  let end = endOfWeek(date, { weekStartsOn });
  if (numberOfWeeks > 1) {
    for (let i = 1, t = numberOfWeeks; i < t; i++) {
      end = endOfWeek(addDays(end, 1), { weekStartsOn });
    }
  }
  return { start, end };
}

export function timeMask(value) {

  const chars = value.split('');

  // var hours;
  // if (chars[0] == '0' || chars[0] == '1' || chars[0] == '2') {
  //     console.log(chars[1])
  //     if (chars[1] == ':' || chars[1] === ' ' || chars[1] === 'Tab') {
  //         // only one digit before the colon: "0", "1", "2"
  //         hours = [/[0-2]/];
  //     } else {
  //         // two digits: 00, 01, 02, 03, 04, ..., 18, 19, 20, 21, 22, 23
  //         hours = [/[0-2]/, chars[0] == '2' ? /[0-3]/ : /[0-9]/];
  //     }
  // } else {
  //     // one digit greater than two: 3, 4, 5, 6, 7, 8, 9
  //     hours = [/[3-9]/];
  // }

  const hours = [
    /[0-2]/,
    chars[0] == '2' ? /[0-3]/ : /[0-9]/
  ];

  // minutes is always two-digits
  const minutes = [/[0-5]/, /[0-9]/, ' ', 'm'];

  return hours.concat(' ').concat('h').concat(' ').concat(minutes);
}

export function IsTimeInStringFormatValid(strTime) {
  let _time = parse(strTime, 'HH:mm', new Date());
  let _valid = isValid(_time);
  if (!_valid) {
    _time = parse(strTime, 'HH:mm aa', new Date());
    _valid = isValid(_time);
  }
  return { valid: _valid, time: _time };
}

export function YupTransformNumber(value, originalValue) {

  if (isNaN(value) || isNaN(originalValue) || IsEmptyOrNullOrUndefined(originalValue) || originalValue === "*") {
    return undefined;
  } else {
    return value;
  }
}

export function YupTransformParseDateString(value, originalValue) {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : parse(originalValue, "yyyy-MM-dd", new Date());

  return parsedDate;
}

export function YupTransformParseTimeString(value, originalValue) {

  const _valid = IsTimeInStringFormatValid(originalValue);
  const parsedDate = _valid.valid
    ? _valid.time
    : originalValue

  return parsedDate;
}

export function GetDiffFromTime(_start, _end) {
  let duration = { days: 0, hours: 0, minutes: 0, seconds: 0, asDays: 0, asHours: 0, asMinutes: 0, asSeconds: 0, newEndTime: _end };
  if (IsEmptyOrNullOrUndefined(_start) || IsEmptyOrNullOrUndefined(_end)) return duration;

  const start = moment(_start);
  let end = moment(_end);
  let _newEnd = end;
  if (!(start.isValid()) || !(end.isValid())) return duration;

  if (start.isAfter(end)) {
    end = end.add(1, 'day');
    _newEnd = end;
  }
  const _duration = moment.duration(end.diff(start));

  duration = {
    asDays: _duration.asDays(),
    asHours: _duration.asHours().toFixed(2),
    asMinutes: _duration.asMinutes(),
    asSeconds: _duration.asSeconds(),
    days: _duration.days(),
    hours: _duration.hours(),
    minutes: _duration.minutes(),
    seconds: _duration.seconds(),
    humanReadable: _duration.humanize(),
    newEndTime: _newEnd.toDate()
  }
  // console.log(duration)
  return duration;
}

export function CombineDateAndTime({ date, time, dateFormat = 'DD-MMM-YYYY', timeFormat }) {
  const _dt = moment(date, dateFormat);
  let _time;
  if (timeFormat) {
    _time = moment(time, timeFormat);
  } else {
    _time = moment(time);
  }

  if (!_dt.isValid() || !_time.isValid()) return null;

  const _newdate = moment(_dt.format('YYYY-MM-DD') + ' ' + _time.format('HH:mm'), 'YYYY-MM-DD HH:mm');
  return _newdate.isValid() ? _newdate.toDate() : null;
}

export async function CheckIfFormIsValid({ trigger }) {
  const _isValid = await trigger();
  if (!_isValid) {
    ShowToast({ title: 'Invalid Fields', message: 'Please fix the errors marked in red.', type: 'error' });
  }
  return _isValid;
}

export async function parseCsv({ file, withHeader = true, delimiter = '' }) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: withHeader,
      skipEmptyLines: true,
      delimiter: delimiter,
      // transform: (value) => {
      //     return value.trim();
      // },
      complete: (results) => {
        return resolve(results);
      },
      error: (error) => {
        return reject(error);
      },
    });
  });
}

export function formatMySqlDateToJsDate(val) {
  if (IsEmptyOrNullOrUndefined(val)) return '';

  return moment(val, "YYYY-MM-DD").toDate();
}

export function formatDate(val, inputFormat, format = "YYYY-MM-DD") {
  let _dt = dayjs(val);
  if (!_dt.isValid() && inputFormat) {
    _dt = dayjs(val, inputFormat);
  }

  const _formattedDate = _dt.isValid() ? _dt.format(format) : '';
  return _formattedDate;
}

export function isBefore(startTime, endTime) {
  return dayjs(startTime).isBefore(dayjs(endTime));
  // return moment(startTime).isSameOrBefore(moment(endTime));
}

export function isAfter(startTime, endTime, format) {
  dayjs.extend(customParseFormat);
  let _end = dayjs(endTime);
  let _start = dayjs(startTime);

  if (!_end.isValid() && format) {
    _end = dayjs(endTime, format)
  }

  if (!_start.isValid() && format) {
    _start = dayjs(startTime, format)
  }

  return _end.isAfter(_start);
}

export function Average(nums) {

  const avg = nums.reduce((a, b) => (strToNumber(a) + strToNumber(b)), 0) / nums.length;
  return (isNaN(avg)) ? 0 : avg;
}

export function AverageExcludeEmpty(nums) {
  const avg = nums.reduce((a, b) => (strToNumber(a) + strToNumber(b)), 0) / nums.filter(x => !IsEmptyOrNullOrUndefined(x)).length;
  return (isNaN(avg)) ? 0 : avg;
}

export function IsEmptyOrNullOrUndefined(val) {
  return !(val !== null && val !== undefined && val.toString().trim().length > 0);
}

export function RoundDown(val, n) {
  const reg = new RegExp("^-?\\d*(?:\\.\\d{0," + n + "})?", "g")
  const a = val.toString().match(reg)[0];
  const dot = a.indexOf(".");
  if (dot === -1) { // integer, insert decimal dot and pad up zeros
    return a + "." + "0".repeat(n);
  }
  const b = n - (a.length - dot) + 1;
  return b > 0 ? (a + "0".repeat(b)) : a;
}

export function strToNumber(val) {
  let v = val === undefined || val == null || val === '' ? 0 : val;
  v = v.toString().replace(",", "");
  if (isNaN(Number(v))) {
    return 0;
  } else {
    return parseFloat(v);
  }
}

export function FormatDateInDDMMMYYYToMySql(str) {
  if (str === undefined || str === null) return str;
  // eslint-disable-next-line no-useless-escape
  let d = str.match(/((\d{1,2})(\-|-)(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)(\-|-)(\d{2,4}))/gi);
  if (d === null) {
    // console.log('check mm/dd/yyyy');
    return FormatDateInString(str, "YYYY-MM-DD");
  }
  d.forEach((v) => {
    const replaceWith = moment(v, "DD-MMM-YYYY").format("YYYY-MM-DD");
    const search = new RegExp(v, "g");
    str = str.replace(search, replaceWith);
  });
  return str;
}

export function FormatDateInString(str, format = "ddd, DD-MMM-YYYY") {
  if (str === undefined || str === null) {
    return str;
  }
  // let d = str.match(/\d{1}(?:\d{1})([\/])\d{1}(?:\d{1})\1\d{2}(?:\d{2})/g);
  // let d = str.match(/\d{2}([\/])\d{2}\1\d{4}/g);

  // eslint-disable-next-line no-useless-escape 
  let d = str.match(/(\d{1,2}(\/|-)\d{1,2}(\/|-)\d{2,4})/g);
  // console.log(str);
  // console.log(d);
  if (d === null) { return str; }
  d.forEach((v) => {
    const replaceWith = moment(v, "MM/DD/YYYY").format(format);
    const search = new RegExp(v, "g");
    str = str.replace(search, replaceWith);
  });
  return str;
}

export function GetObjectValueFromList(source, field, search) {
  const f = source.find(s => s[field].toString().toLowerCase() === (search || '').toString().toLowerCase());

  return (f === undefined ? null : f);
}

export function agGridNumberFormatter(val, negativeInParenthesis, showPercent, emptyNullOrZeroAsDash, decimalscale) {
  if (emptyNullOrZeroAsDash && strToNumber(val) === 0) {
    return '-';
  }

  if (decimalscale !== undefined && decimalscale !== null) {
    val = strToNumber(val).toFixed(decimalscale);
  }
  return numeral(val).format('(0,0[.][000000])')
  // return formatNumber(val, negativeInParenthesis, showPercent, emptyNullOrZeroAsDash);
}

export function agGridNumberFormat(val, negativeInParenthesis, showPercent, emptyNullOrZeroAsDash, decimalscale, emptyNullAsEmpty, forceDisplayDecimal, currencySymbol) {
  if (emptyNullOrZeroAsDash && strToNumber(val) === 0) {
    return '-';
  }

  if (emptyNullAsEmpty && (val === null || val === undefined || val === '')) {
    return '';
  }

  if (decimalscale !== undefined && decimalscale !== null) {
    val = strToNumber(val).toFixed(decimalscale);
  }

  if (!currencySymbol) { currencySymbol = ''; }

  let format = `(0,0`;

  if (decimalscale && decimalscale > 0) {
    let zeros = '';
    zeros = zeros.padStart(decimalscale, 0);
    if (forceDisplayDecimal) {
      format += '.';
    } else {
      format += '[.]';
    }
    format += zeros + '';
  }

  format += ')';

  return currencySymbol + ' ' + numeral(val).format(format);
  // return numeral(val).format('(0,0[.][000000])')
  // return formatNumber(val, negativeInParenthesis, showPercent, emptyNullOrZeroAsDash);
}

function formatNumberWithComma(num) {
  // return numeral(num).format('(0,0[.][000000])')
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export const AccountingFormatter = ({ val, precision = 0, currencySymbol = '' }) => {
  return formatMoney(val, { precision: precision, symbol: currencySymbol, thousand: ",", format: { pos: "%s %v", neg: "%s (%v)", zero: "-" } });

}

export function FormatNumber(val, decimalScale, forceDisplayDecimal, currencySymbol) {
  if (decimalScale !== undefined && decimalScale !== null) {
    val = strToNumber(val).toFixed(decimalScale);
  }

  if (!currencySymbol) { currencySymbol = ''; }

  let format = `(0,0`;

  if (decimalScale && decimalScale > 0) {
    let zeros = '';
    zeros = zeros.padStart(decimalScale, 0);
    if (forceDisplayDecimal) {
      format += '.';
    } else {
      format += '[.]';
    }
    format += zeros + '';
  }

  format += ')';
  // console.log(format);
  return currencySymbol + ' ' + numeral(val).format(format);
}

export function formatNumber(num, negativeInParenthesis, showPercent, emptyNullOrZeroAsDash) {
  if (IsEmptyOrNullOrUndefined(num)) {
    return (emptyNullOrZeroAsDash ? '-' : '');
  }
  let newVal = formatNumberWithComma(num);
  if (showPercent) {
    newVal = newVal + '%';
  }

  let v = strToNumber(num);
  if (negativeInParenthesis && v < 0) {
    newVal = "(" + formatNumberWithComma(Math.abs(v)) + (showPercent ? '%' : '') + ")";
  }

  if (emptyNullOrZeroAsDash && v === 0) {
    newVal = "-";
  }

  return newVal;
}

export function dateToStringFormat(dt, srcFormat = 'YYYY-MM-DD', outFormat = 'YYYY-MM-DD') {
  let d = dt;

  if (dt === '' || dt === null || dt === undefined) {
    return null;
  }
  if (typeof dt === 'string') {
    d = moment(dt, srcFormat);
  }
  // console.log(d);
  return d.format(outFormat);
}

export async function copyTextToClipboard(text) {
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand('copy', true, text);
  }
}

export function getUUID(extra) {
  if (extra) {
    return uuid_v4() + extra;
  } else {
    return uuid_v4();
  }
};

export function toFixedNoRounding(val, decimalScale = 2) {
  let flr = 1;
  for (let x = 1; x <= decimalScale; x++) {
    flr *= 10;
  }

  return Math.floor(val * flr) / flr;
}

export function ShowIfNotEmpty(val) {
  // console.log(val)
  if (!IsEmptyOrNullOrUndefined(val) && val.indexOf('undefined') === -1) {
    return val;
  } else {
    return '';
  }
}

export function GetAllNonEmptyRowsOfGrid(grid, excludeFields) {
  let _rows = [];
  if (!grid) return _rows;

  grid.forEachNode(node => {
    let _isEmpty = true;
    for (const key in node.data) {
      if (excludeFields && Array.isArray(excludeFields) && excludeFields.indexOf(key) !== -1) {
        continue;
      } else if (excludeFields && key === excludeFields) {
        continue;
      }

      if (node.data.hasOwnProperty(key) && (!IsEmptyOrNullOrUndefined(node.data[key]))) {
        // _rows.push(node.data);
        _isEmpty = false;
        break;
      }
    }

    if (!_isEmpty) {
      _rows.push(node.data);
    }
  });
  return _rows;
}

export const AgGridDateComparator = (date1, date2, format) => {
  if (IsEmptyOrNullOrUndefined(date1) && IsEmptyOrNullOrUndefined(date2)) { return; }
  if (IsEmptyOrNullOrUndefined(date1)) { return -1; }
  if (IsEmptyOrNullOrUndefined(date2)) { return 1; }
  const d1 = moment(date1, format).format('YYYYMMDD');
  const d2 = moment(date2, format).format('YYYYMMDD');

  // console.log(d1);
  // console.log(d2);
  // console.log(+d1 - +d2);
  return +d1 - +d2;


  // if (d1.isAfter(d2)) { console.log('1'); return 1; }
  // else if (d1.isBefore(d2)) { return -1; }
  // else { return 0; }
}

export const AgGridHeaderComponentParams =
  '<div class="ag-cell-label-container" role="presentation">' +
  '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
  '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
  '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order notabsolute"></span>' +
  '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon notabsolute"></span>' +
  '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon notabsolute"></span>' +
  '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon notabsolute"></span>' +
  '    <span ref="eText" class="ag-header-cell-text notabsolute font-weight-boldest" role="columnheader" style="white-space: normal;"></span>' +
  '    <span ref="eFilter" class="ag-header-icon ag-filter-icon notabsolute"></span>' +
  '  </div>' +
  '</div>';

export const SetGridMinimumRows = ({ list, minimumNoOfRows, primaryKeyName, addExtraRow = true }) => {
  console.log("🚀 ~ SetGridMinimumRows ~ primaryKeyName:", primaryKeyName)
  console.log("🚀 ~ SetGridMinimumRows ~ list:", list)
  let _toAdd = JSON.parse(JSON.stringify(list || []));
  let _obj = {};

  for (let _rowCnt = (list || []).length; _rowCnt < +minimumNoOfRows; _rowCnt++) {
    _obj = {};
    _obj[primaryKeyName] = getUUID();
    _toAdd.push(_obj);
  }

  // 
  if (addExtraRow && (list || []).length >= +minimumNoOfRows) {
    _obj = {};
    _obj[primaryKeyName] = getUUID();
    _toAdd.push(_obj);
  }

  console.log('_toAdd: ', _toAdd)
  return _toAdd;
}

export const GetValueFromList = ({ list, field, value, text }) => {
  const found = list.find(l => l[field]?.toString() === value.toString());
  if (found) {
    return found[text]
  }
  return null;
}

export const Iif = ({ condition, ifTrue = '', ifFalse = '' }) => {
  if (condition) {
    return ifTrue;
  } else {
    return ifFalse;
  }
}

export const IsValidUuid = (uuid) => {
  return validate_uuid(uuid);
}

export const ConcatIfNotNull = (val1, val2, delimiter = ' ') => {
  return [val1, val2].filter(Boolean).join(delimiter);
}

export function KgLitersConversionToNumber(val) {
  return strToNumber((val || '')?.toString()?.toLowerCase()?.replace(/,/g, '')?.replace(/kg/g, '')?.replace(/lit/g, '')?.replace(/lt/g, ''));
}

export function SetToEmptyIfEmpty(fields, list) {
  let newList = Object.assign({}, list);
  console.log(newList)
  fields.forEach(key => {
    for (let i = 0, t = list.length; i < t; i++) {
      if (IsEmptyOrNullOrUndefined(newList[i][key])) {
        newList[i][key] = null;
      }
    }
  })

  console.log(newList)
  return list;
}

export function IsStringEqual(str1, str2) {
  return str1 === str2;
}

export function IsStringContains(str1, search) {
  return ((str1 || '').toString().toLowerCase().includes(search.toLowerCase()))
}

export const TimePickerInput = (props) => {
  return (
    <TimePickerComponent
      {...props}
    />
  )
}

export const isObjEmpty = (obj) => Object.keys(obj).length === 0;